import { Component, HostListener, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { environment } from '../../../../../environments/environment';
import { PARAMS } from 'src/app/_configs/params';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-slick-slider',
  templateUrl: './slick-slider.component.html',
  styleUrls: ['./slick-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class SlickSliderComponent implements OnInit {
  @Input() tenders: Array<any> = [];
  @Input() type: any;
  @Input() dataType: any;

  private scrollEvent$ = new Subject<Event>();

  baseUrl: string = environment.TENDER.BASE_URL;
  imageBasePath: string = environment.TENDER.IMAGE_BASE_URL;
  slideConfig: any;
  isCurrentUserAgentIsMobile: boolean = false;
  isMobile: boolean = true;

  numberOfItems: number = 1;
  isScroll: boolean = true;
  containerId: string = "slider-" + Math.random().toString(36).substr(2, 9);
  hideContainer = false;
  topPerformingContainer = 'top-performing-inner-container';
  isLeftVisible: boolean = false;
  isRightVisible: boolean = true;
  scrollAmount = 0;
  static callCounter: number = 0;

  constructor(private sharedService: SharedService, private renderer: Renderer2) {
    this.onResize()
    SlickSliderComponent.callCounter++;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    this.filterVisibleoOnMobile();
  }
  cardRows: any[] = [];
  // tendersData: any[] | null = null;

  ngOnInit(): void {
    // Debounce the scroll event
    this.scrollEvent$.pipe(debounceTime(100)).subscribe((event: Event) => this.handleScroll(event)); // Explicitly define event type here
    this.filterVisibleoOnMobile();
    this.containerId = this.containerId + SlickSliderComponent.callCounter;
    this.preloadImages();
    this.splitCardsIntoRows(this.tenders);

    // this.filterVisibleoOnMobile()
    // this.containerId = this.containerId + SlickSliderComponent.callCounter;
    // this.preloadImages()
    // this.splitCardsIntoRows(this.tenders);
  }

  splitCardsIntoRows(tenderdata: any): void {
    const rowCount = 2;
    const cardsPerRow = Math.ceil(tenderdata.length / rowCount);
    for (let i = 0; i < rowCount; i++) {
      const start = i * cardsPerRow;
      const end = start + cardsPerRow;
      this.cardRows.push(tenderdata.slice(start, end));
    }
  }



  preloadImages() {
    if (this.sharedService.isBrowser) {
      if (this.tenders && this.tenders.length > 1) {
        const secondItem = this.tenders[1];
        if (secondItem && secondItem.link) {
          const imageUrl = `${this.imageBasePath}${secondItem.link}.webp`;
          this.addPreloadLink(imageUrl);
        }
      }
    }
  }

  addPreloadLink(url: string) {
    if (this.sharedService.isBrowser) {
      const linkElement = this.renderer.createElement('link');
      this.renderer.setAttribute(linkElement, 'rel', 'preload');
      this.renderer.setAttribute(linkElement, 'as', 'image');
      this.renderer.setAttribute(linkElement, 'href', url);
      this.renderer.appendChild(document.head, linkElement);
    }
  }

  filterVisibleoOnMobile() {
    if (this.sharedService.isBrowser) {
      if (window.outerWidth < PARAMS.STATIC_PARAMS.WINDOWS_OUTER_WIDTH) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  }

  trackById(index: number, item: any): number {
    return item?.id || index; // Assuming your tenders have a unique 'id' field
  }

  trackByIndex(index: number): number {
    return index;
  }

  /**
   * Navigate to tenders page with full page reload
   * This bypasses Angular's internal routing and triggers a full page reload
   * to pull fresh data from the CDN instead of using cached data
   */
  navigateToTenders(link: string): void {
    window.location.href = `/${link}-tenders/active`;
  }

  /**
   * Navigate to tenders page with full page reload (for image clicks)
   * This bypasses Angular's internal routing and triggers a full page reload
   * to pull fresh data from the CDN instead of using cached data
   */
  navigateToTendersImg(link: string, event: Event) {
    event.preventDefault(); // Prevent default action
    window.location.href = `/${link}-tenders/active`;
  }

  handleImageError(event: any): void {
    event.target.src = this.imageBasePath + 'banner/default.webp';
  }

  onSliderScroll(event: Event) {
    const data = this.sharedService.onScroll(event);
    this.isRightVisible = data?.isRightVisible;
    this.isLeftVisible = data?.isLeftVisible
    this.scrollEvent$.next(event);
  }

  // onSliderScroll(event: Event): void {

  // }

  handleScroll(event: Event): void {
    const data = this.sharedService.onScroll(event);
    this.isRightVisible = data?.isRightVisible;
    this.isLeftVisible = data?.isLeftVisible;
  }

  scrollSliderDiv(right?: any) {
    this.sharedService.scrollDiv(this.containerId, this.numberOfItems, right);
  }

}
